// src/routes/RequireAuth.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isTokenValid, getAccessToken, getRefreshToken } from "../auth";
import { extendLogin } from "../api";

export default function RequireAuth({ children }) {
  const location = useLocation();

  // 내부 상태: 검사 완료 여부 / 통과 여부
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function checkAuth() {
      const access = getAccessToken?.() || localStorage.getItem("accessToken");
      const refresh = getRefreshToken?.() || localStorage.getItem("refreshToken");

      // 1) access 유효하면 바로 통과
      if (isTokenValid(access)) {
        if (mounted) {
          setAllowed(true);
          setReady(true);
        }
        return;
      }

      // 2) access 만료지만 refresh 유효하면 즉시 갱신 시도
      if (isTokenValid(refresh)) {
        try {
          await extendLogin(); // 새 access(+회전된 refresh) 저장
          if (mounted) setAllowed(true);
        } catch (e) {
          console.warn("[RequireAuth] refresh 실패:", e);
          if (mounted) setAllowed(false);
        } finally {
          if (mounted) setReady(true);
        }
        return;
      }

      // 3) 둘 다 만료 → 로그인으로
      if (mounted) {
        setAllowed(false);
        setReady(true);
      }
    }

    checkAuth();
    return () => {
      mounted = false;
    };
  }, []);

  // 아직 검사 중이면 렌더 지연(필요시 스피너 넣어도 됨)
  if (!ready) return null;

  if (!allowed) {
    // 이미 /login이면 그대로 렌더(루프 방지)
    if (location.pathname === "/login") return children;
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 통과
  return children;
}
